import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { memo } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 430,
  bgcolor: "#282F42",
  boxShadow: 24,
  borderRadius: "10px",
};

function RemoveOrderModal(props) {
  const handleClose = (reason) => {
    if (reason && reason === "backdropClick") return;
    props.setOpenRemoveOrderModal(false);
  };

  return (
    <>
      <Modal
        open={props.openRemoveOrderModal}
        // BackdropProps={false}
        onHide={handleClose}
        // onClose={handleClose}
        backdrop="static"
        keyboard="false"
      >
        <Box sx={style}>
          <div className="text-white p-8 items-center flex justify-center flex-col">
            <p> {process.env.REACT_APP_INSTRUCTIONTYPE==='WASTECOLLECTION'?"Are you sure you want to cancel this pickup?":`Are you sure want to remove this order ${props.deleteOrder}?`}</p>
            <div className="flex w-full gap-1 mt-4 justify-around">
              <button
                className="text-white w-2/5 bg-[#00b7d4] rounded p-2"
                onClick={() => {
                  handleClose();
                  props.deleteOrder(props.deletedOrderId);
                }}
              >
                {" "}
                Yes
              </button>
              <button
                className="text-white w-2/5 border-1 border-white rounded p-2"
                onClick={handleClose}
              >
                {" "}
                No
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
export default memo(RemoveOrderModal);
